export default __webpack_public_path__ + "static/media/iconArrowRight.aa909eae.svg";